import type { ChartOptions } from 'chart.js'

export const TOOLTIP_PLUGIN_OPTIONS = {
  backgroundColor: '#141644',
  titleAlign: 'center',
  boxPadding: 4
} as const

export const DATALABELS_PLUGIN_OPTIONS = {
  clamp: true,
  font: {
    size: 13,
    weight: 300
  },
  opacity: 0.8
} as const

export const SCALES_OPTIONS = {
  x: {
    grid: {
      drawOnChartArea: false,
      drawTicks: false
    },
    ticks: {
      display: true,
      padding: 16,
      color: '#9f9eab'
    },
    border: {
      display: false
    }
  },
  y: {
    grid: {
      drawOnChartArea: false,
      drawTicks: false
    },
    ticks: {
      display: true,
      maxTicksLimit: 5,
      color: '#9f9eab'
    },
    border: {
      display: false
    },
    beginAtZero: false
  }
} as const

export const DEFAULT_CHART_OPTIONS: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: SCALES_OPTIONS,
  plugins: {
    tooltip: TOOLTIP_PLUGIN_OPTIONS,
    datalabels: DATALABELS_PLUGIN_OPTIONS
  }
}

export const COLOR_TRANSPARENCY_SUFFIX = '80'
